import React from 'react';
import InfoGrid from "../../../../../../components/info-grid/info-grid.jsx";
import projectUtils from "../../../../../../utils/project-utils.js";
import ProjectUtils from "../../../../../../utils/project-utils.js";

const OccurrenceVehicle = ({data}) => {
    const vehicles = data.vehicles ?? [];

    return (
        <>
            { vehicles.map((vehicle, index) => {
                const personName = data.individuals.find(i => i.itemId === vehicle.relatedPerson)?.name ?? "";

                const vehiclesInfo = [
                    {
                        label: "Placa",
                        value: ProjectUtils.formatUniversalPlate(vehicle.plate),
                    },
                    {
                        label: "Classificação",
                        value: vehicle.classification,
                    },
                    {
                        label: "Tipo (Denatran)",
                        value: vehicle.type,
                    },
                    {
                        label: "Marca/Modelo",
                        value: vehicle.brandModel,
                    },
                    {
                        label: "Cor",
                        value: vehicle.color,
                    },
                    {
                        label: "Município da placa",
                        value: vehicle.city,
                    },
                    {
                        label: "Pessoa relacionada",
                        value: personName,
                    },
                    {
                        label: "Ano da fabricação",
                        value: vehicle.fabricationYear,
                    },
                    {
                        label: "Ano de modelo",
                        value: vehicle.modelYear,
                    },
                    {
                        label: "Portas",
                        value: vehicle.numPorts,
                    },
                    {
                        label: "Blindado",
                        value: vehicle.armoredVehicle ? "Sim" : "Não",
                    },
                    {
                        label: "RENAVAM",
                        value: vehicle.renavam,
                    },
                    {
                        label: "Chassi",
                        value: vehicle.chassis,
                    },
                    {
                        label: "Motor",
                        value: vehicle.engineNumber,
                    },
                    {
                        subTitle: "Dados do proprietário",
                        items: [
                            {
                                label: "CPF/CNPJ",
                                value: projectUtils.formatCpfCnpjToView(vehicle.cpfCnpjOwner),
                            },
                            {
                                label: "Telefone",
                                value: vehicle.ownerPhone,
                            },
                            {
                                label: "Nome",
                                value: vehicle.owner
                            },
                        ],
                    },
                    {
                        subTitle: "Dados do possuidor",
                        items: [
                            {
                                label: "CPF/CNPJ",
                                value: projectUtils.formatCpfCnpjToView(vehicle.cpfCnpjPossessor),
                            },
                            {
                                label: "Telefone",
                                value: vehicle.possessorPhone,
                            },
                            {
                                label: "Nome",
                                value: vehicle.possessor
                            },
                        ],
                    },
                ];

                return (
                    <InfoGrid key={vehicle.itemId ?? index} title={`VEÍCULO - ${index+1}`} items={vehiclesInfo} columns={3} labelClassName="text-[#4F4F4F] text-[13px] print:text-[15px]!" valueClassName={'print:text-[17px]!'} titleClassName={'print:text-[19px]! print:break-after-avoid!'} contentClassName={'space-y-1 print:break-inside-avoid!'}/>
                );
            })}
        </>
    );
};

export default OccurrenceVehicle;